import React from 'react';
import { isEmpty } from 'lodash';
import { usePipelinePageContext } from 'app/pipeline-details/PipelinePageContextProvider';
import BasePipelineIntegrationSelect from './BasePipelineIntegrationSelect/BasePipelineIntegrationSelect';
import { useTestPipelineDrawerContext } from 'app/pipeline-details/StatusItem/TestPipelineDrawerContextProvider';

export default function PipelineIntegrationSelect() {
  const {
    pipeline: { pipelineIntegrations },
  } = usePipelinePageContext();
  const {
    state: { selectedPipelineIntegrationId, onSelectPipelineIntegration },
  } = useTestPipelineDrawerContext();
  return (
    <BasePipelineIntegrationSelect
      disabled={isEmpty(pipelineIntegrations)}
      selectedPipelineIntegrationId={selectedPipelineIntegrationId}
      pipelineIntegrations={pipelineIntegrations}
      onChange={onSelectPipelineIntegration}
      data-test-id="pipeline-integration-select"
    />
  );
}
